var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g(_vm._b({tag:"component",staticClass:"lp-button",class:`lp-button--${_vm.size}`,style:(_vm.rootStyle),attrs:{"href":_vm.href || null,"type":_vm.href ? null : _vm.type}},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }